'use strict';
require('./visibility-observer');
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.sidebarWidget = function (splittableModel) {
	return this.each(function () {
		const element = this.addClass('hidden').visibilityObserver(),
			sidebarName = element.attr('data-mm-sidebar-name'),
			sideBarSize = element.attr('data-mm-sidebar-size'),
			showSidebar = function () {
				element.removeClass('hidden');
			},
			hideSidebar = function () {
				element.addClass('hidden');
			};
		splittableModel.register(sidebarName, sideBarSize);
		splittableModel.addEventListener('show', function (sidebar) {
			if (sidebar ===	sidebarName) {
				showSidebar();
			} else {
				hideSidebar();
			}
		});
		splittableModel.addEventListener('hide', hideSidebar);
	});
};
